import React from "react";
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import Tickets from "../TicketsCustom"
import TicketAdvanced from "../TicketsAdvanced";

function TicketResponsiveContainer (props) {
    const content = isWidthUp('md', props.width)
        ? <Tickets />
        : <TicketAdvanced />;

    return content;
}

export default withWidth()(TicketResponsiveContainer);
